export interface AppData {
    id: string;
    name: string;
    description: string;
    icon: string;
    status: {
        platform: string;
        version: string;
        status: string;
    }[];
    features: string[];
    screenshots: string[];
    appStoreLink?: string;
    googlePlayLink?: string;
    webLink?: string;
    customHero?: {
        imageUrl: string;
        titleColor: string;
        descColor: string;
    }
}

export const apps: AppData[] = [
    {
        id: "super-focus-time",
        name: "Super Focus Time",
        description: "A productivity app designed to help users focus and manage their time effectively.",
        icon: "/images/super-focus-time/app_icon.png",
        status: [
            {
                platform: "iOS",
                version: "1.3",
                status: "Ready for Distribution"
            }
        ],
        features: [
            "Customizable focus sessions",
            "Track productivity patterns",
            "Notification blocking during focus time",
            "Progress statistics",
            "Goal setting for productivity"
        ],
        screenshots: [
            "/images/super-focus-time/screen_1.png",
            "/images/super-focus-time/screen_2.png",
            "/images/super-focus-time/screen_3.png",
            "/images/super-focus-time/screen_4.png",
            "/images/super-focus-time/screen_5.png",
            "/images/super-focus-time/screen_6.png",
        ],
        appStoreLink: "https://apps.apple.com/us/app/super-focus-time/id6743349720",
        googlePlayLink: "https://play.google.com/store/apps/details?id=com.planetb.focustime"
    },
    {
        id: "powermega-lottery",
        name: "Powermega Lottery App",
        description: "An AI-powered lottery app with jackpot updates, number generators, result tracking, and group play.",
        icon: "/images/powermega-lottery/powermega.svg",
        status: [
            {
                platform: "iOS",
                version: "4.4",
                status: "Ready for Distribution"
            }
        ],
        features: [
            "Random number generation",
            "Historical results database",
            "Winning odds calculator",
            "Drawing alerts",
            "Ticket scanning"
        ],
        screenshots: [
            "/images/powermega-lottery/03-ticket-scan.jpg",
            "/images/powermega-lottery/05-tickets.jpg",
            "/images/powermega-lottery/06-number-stats.jpg",
            "/images/powermega-lottery/07-number-generator.jpg",
            "/images/powermega-lottery/08-group-play.jpg",
            "/images/powermega-lottery/09-more-page.jpg"
        ],
        appStoreLink: "https://apps.apple.com/us/app/powermega-lottery-app/id1495566672",
        googlePlayLink: "",
        customHero: {
            imageUrl: "/images/powermega-lottery/hero-image.png",
            titleColor: '#f57c00',
            descColor: '#ffffff'
        }
    },
    {
        id: "ask-the-crew",
        name: "Ask The Crew",
        description: "A Q&A platform connecting users with experts from various fields.",
        icon: "/images/ask-the-crew/app_icon.png",
        status: [
            {
                platform: "iOS",
                version: "1.0",
                status: "Prepare for Submission"
            }
        ],
        features: [
            "Direct Q&A with verified experts",
            "Topic categorization",
            "Upvoting system for answers",
            "Follow topics of interest",
            "Notifications for answered questions"
        ],
        screenshots: [
            "/images/ask-the-crew/home_screen.png",
            "/images/ask-the-crew/advice_screen.png"
        ],
        appStoreLink: "",
        googlePlayLink: ""
    },
    {
        id: "super-soundboard",
        name: "Super Soundboard App!!",
        description: "A comprehensive soundboard app with a vast library of sound effects and custom recording options.",
        icon: "/images/super-soundboard/app_icon.png",
        status: [
            {
                platform: "iOS",
                version: "1.3.1",
                status: "Ready for Distribution"
            }
        ],
        features: [
            "Thousands of pre-loaded sound effects",
            "Custom recording and editing",
            "Sound organization by categories",
            "Quick access favorites",
            "Create custom soundboards"
        ],
        screenshots: [
            "/images/super-soundboard/categories.png",
            "/images/super-soundboard/category_list.png",
            "/images/super-soundboard/home_screen.png",
            "/images/super-soundboard/timer.png"],
        appStoreLink: "https://apps.apple.com/us/app/super-soundboard-app/id1550044160",
        googlePlayLink: "https://play.google.com/store/apps/details?id=com.planetbinc.supersoundboard2"
    },
    {
        id: "super-word-wizard",
        name: "Super Word Wizard",
        description: "A word game that tests vocabulary and spelling skills with increasing difficulty levels.",
        icon: "/images/super-word-wizard/app_icon.png",
        status: [
            {
                platform: "iOS",
                version: "1.1.0",
                status: "Ready for Distribution"
            }
        ],
        features: [
            "Multiple word games in one app",
            "Vocabulary builder",
            "Daily challenges",
            "Competitive leaderboards",
            "Educational content for all ages"
        ],
        screenshots: [
            "/images/super-word-wizard/screen_1.png",
            "/images/super-word-wizard/screen_2.png",
            "/images/super-word-wizard/screen_3.png",
            "/images/super-word-wizard/screen_4.png",
        ],
        appStoreLink: "https://apps.apple.com/us/app/super-word-wizard/id6448690485",
        googlePlayLink: "https://play.google.com/store/apps/details?id=com.planetb.wordwizard"
    },
    {
        id: "tip-calc",
        name: "Super Tip Calc",
        description: "Super-Simple way to calculate the tip and split the bill! Use your camera to scan your receipt and fill in the Total Bill automatically!",
        icon: "/images/tip-calc/app_icon.png",
        status: [
            {
                platform: "iOS",
                version: "1.3.4",
                status: "Ready for Distribution"
            }
        ],
        features: [
            "Receipt scanning with camera",
            "Easy tip calculation",
            "Bill splitting among multiple people",
            "Customizable tip percentages",
            "Tax calculation",
            "Clean, intuitive interface",
            "History of previous calculations",
            "No data collection - privacy focused",
            "Works on iPhone, iPad and Apple Vision"
        ],
        screenshots: [
            "/images/tip-calc/screen_1.png",
            "/images/tip-calc/screen_2.png",
            "/images/tip-calc/screen_3.png",
            "/images/tip-calc/screen_4.png",
            "/images/tip-calc/screen_5.png",
            "/images/tip-calc/screen_6.png",
        ],
        appStoreLink: "https://apps.apple.com/us/app/tip-calc-super-tip-calculator/id6443862641",
        googlePlayLink: "https://play.google.com/store/apps/details?id=com.planetb.tipcalc",
        webLink: "/tipcalc"
    },
    {
        id: "relaxing-sounds",
        name: "Relaxing Sounds App",
        description: "An app with a collection of relaxing sounds to help with meditation, sleep, and stress reduction.",
        icon: "/images/relaxing-sounds/app_icon.png",
        status: [
            {
                platform: "iOS",
                version: "1.1",
                status: "Ready for Distribution"
            }
        ],
        features: [
            "High-quality nature sounds",
            "Customizable sound mixes",
            "Timer for auto-shutdown",
            "Background play support",
            "Meditation guides and programs"
        ],
        screenshots: [
            "/images/relaxing-sounds/screen_1.png",
            "/images/relaxing-sounds/screen_2.png",
            "/images/relaxing-sounds/screen_3.png",
            "/images/relaxing-sounds/screen_4.png",
        ],
        appStoreLink: "https://apps.apple.com/us/app/relaxing-sounds-calming-app/id1560933473",
        googlePlayLink: "https://play.google.com/store/apps/details?id=com.planetb.relaxingsounds"
    },
    {
        id: "alien-blaster",
        name: "Alien Banana Blaster",
        description: "A retro alien blaster game with a twist.",
        icon: "/images/alien-blaster/app_icon.png",
        status: [
            {
                platform: "iOS",
                version: "1.1.0",
                status: "Ready for Distribution"
            }
        ],
        features: [
            "Retro Alien Blaster game",
            "Blast aliens to save the planet",
            "Test your reflexes",
            "Look for the UFO for bonus points",
            "Find the auto-fire feature"
        ],
        screenshots: [
            "/images/alien-blaster/screen_1.png",
            "/images/alien-blaster/screen_2.png",
            "/images/alien-blaster/screen_3.png",
            "/images/alien-blaster/screen_4.png",
        ],
        appStoreLink: "https://apps.apple.com/us/app/alien-banana-blaster/id6745722377",
        googlePlayLink: "https://play.google.com/store/apps/details?id=com.planetbinc.alienblaster",
        webLink: "/alienblaster"
    },
    {
        id: "joes-world",
        name: "Joe's World",
        description: "If OCD were an app, this would be it.",
        icon: "/images/joes-world/app_icon.png",
        status: [
            {
                platform: "iOS",
                version: "1.1.0",
                status: "Ready for Distribution"
            }
        ],
        features: [
            "If OCD were an app, this would be it.",
            "A clean, minimalistic app that helps you organize your life.",
            "Swiss army knife for your life.",
        ],
        screenshots: [
            "/images/joes-world/screen_1.png",
            "/images/joes-world/screen_2.png",
        ],
        appStoreLink: "https://apps.apple.com/us/app/joes-world-meet-up-app/id1588592476",
        googlePlayLink: "https://play.google.com/store/apps/details?id=com.planetbinc.seeyou"
    },
    {
        id: "super-budget",
        name: "SuperBudget",
        description: "Track your expenses and organize your finances with ease.",
        icon: "/images/super-budget/app_icon.png",
        status: [
            {
                platform: "iOS",
                version: "1.1.0",
                status: "Ready for Distribution"
            }
        ],
        features: [
            "Track your expenses and organize your finances with ease.",
            "Create budgets and track your spending.",
            "View your financial history.",
            "Set financial goals and track your progress.",
            "View charts and full year overview.",
        ],
        screenshots: [
            "/images/super-budget/screen_1.png",
            "/images/super-budget/screen_2.png",
            "/images/super-budget/screen_3.png",
            "/images/super-budget/screen_4.png",
        ],
        appStoreLink: "https://apps.apple.com/us/app/superbudget-track-expenses/id6782244860",
        googlePlayLink: "https://play.google.com/store/apps/details?id=com.planetbinc.superbudget",
        webLink: "/superbudget"
    }

];